<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gbv9Dv/tc-custom/9780062290953.jpg?1731012178756" alt="This image is the cover for the book Hallowed Isle: The Book of the Cauldron, The Hallowed Isle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hallowed Isle: The Book of the Cauldron, The Hallowed Isle
      </h1>
      <p class="bookDescription body article font2">
        <p>The Romans came, conquered, and departed, leaving behind them a strange new religion called Christianity. The princes of Britannia have driven back the invading Saxons and dream of a return to bygone days, while others on the island invoke the magic of a time older still. For the revered ancient goddesses Eve on in the hearts and memories of the proud royal women of the old British tribes. And now, King Artor -- wounded in body and spirit -- proclaims that the sword and the spear must be put to rest, and summons his mother Igierne, Lady of the Lake, to use the powers of the Cauldron to heal a troubled, wartorn land. But old jealousies and new power struggles threaten disaster, as Artor's sister Morgause hides a deadly secretand a darker magic. It is Guendivar the queen who holds the key to their survival, if she can master her own power in time.</p><p>For a darkness is emanating from high places -- and it threatens to devastate a realm.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana L. Paxson
      </h2>
      
      <p class="authorDescription body article"><P>Diana L. Paxson is the award-winning author of <I>The Lord of Horses, The Wolf and the Raven, The Dragons of the Rhine, The White Raven,</I> and <I>The Serpents Tooth,</I> and coauthor (with Adrienne Martine-Barnes) of <I>Master of Earth and Water, The Shield Between the Worlds,</I> and <I>Sword of Fire and Shadow,</I> the chronicles of Fionn mac Cumhal. She lives in Berkeley, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?383c5511